import React, { Component } from 'react';

class Error extends Component {

  

  render() {
    const { translation } = this.props;
    return (
        <main className="page__container label-page">
            <img className="label-page__image label-page__image--hands" src="/images/hands.png" alt="Hands" />
            <h1 className="label-page__heading">¡Oops!</h1>
            <p>{translation('NO_MORE_QUESTIONS')}</p>
            <label className="label-page__main-button main-button main-button--colored" onClick={  ()=>   window.open('gbrappi://com.grability.rappi?goto=home', '_self')  }>
              <span className="main-button__label">{translation('GO_BACK_RAPPI')}</span>
              <svg className="main-button__icon" width={25} height={25}>
                  <use xlinkHref="/images/sprite.svg#arrow_down" />
              </svg>
            </label>
        </main>
    );
  }

}

export default Error;
